import "./App.css";

import Home from "./pages/home";
import { LocalizationProvider } from "@mui/lab";
import DateAdapter from "@mui/lab/AdapterDayjs";
import esLocale from "dayjs/locale/es";

import {
  ConfirmationResult,
  getAuth,
  onAuthStateChanged,
  RecaptchaVerifier,
  signInWithPhoneNumber,
} from "firebase/auth";
import { useEffect, useRef, useState } from "react";
import app from "./firebase/app";
import { useAppDispatch, useAppSelector } from "./redux/hooks";
import { selectToken, setToken } from "./redux/reducers/authSlice";
import { useGetProfileQuery } from "./redux/query/endpoints";

function App() {
  const auth = getAuth(app);

  const dispatch = useAppDispatch();

  const token = useAppSelector(selectToken);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (snap) => {
      if (snap?.phoneNumber) {
        console.log(snap);
        snap.getIdToken().then((token) => {
          dispatch(setToken(token));
          localStorage.firebase_token = token;
        });
      } else {
        dispatch(setToken(""));
        localStorage.removeItem("firebase_token");
      }
    });
    return () => unsub();
  }, [auth, dispatch]);

  return (
    <LocalizationProvider dateAdapter={DateAdapter} locale={esLocale}>
      <Home />
    </LocalizationProvider>
  );
}

export default App;
